import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch } from 'react-router-dom';
import configureStore from './store';
import { PrivateLayout, PublicLayout } from 'layouts';
import {
  LoginPage,
  ChatPage,
  PsychicsPage,
  ConversationsPage,
  UsersPage,
  UserReports,
  CohortSearch,
  Stats,
  StatsAcc,
  StatsAccPerEnv,
  DailyStats
} from 'pages';
import { LocaleProvider } from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import 'utils/timetracker';
import { chartPageType } from './pages/stats_acc/StatsAcc';
import { envChartPageType } from './pages/stats_acc_per_env/StatsAccPerEnv';
import { conversationPageType } from 'pages/conversations/ConversationsPage';
import { dailyStatsChartPageType } from './pages/daily_stats/DailyStats';

const store = configureStore();

export default class App extends Component {
  render() {
    return (
      <Provider store={ store }>
        <LocaleProvider locale={ enUS }>
          <BrowserRouter>
            <div>
              <PublicLayout exact path="/login" component={ LoginPage } />
              <Switch>
                <PrivateLayout exact path="/" pt={ conversationPageType.paid } component={ ConversationsPage } />
                <PrivateLayout exact path="/stats" component={ Stats } />
                <PrivateLayout exact path="/stat-charts" pt={ chartPageType.messagesTime } component={ StatsAcc } />
                <PrivateLayout exact path="/stat-c-charts" pt={ chartPageType.conversions } component={ StatsAcc } />
                <PrivateLayout exact path="/stat-env-m-charts" pt={ envChartPageType.messagesRevenue } component={ StatsAccPerEnv } />
                <PrivateLayout exact path="/daily-stats" pt={ dailyStatsChartPageType.sales } component={ DailyStats } />
                <PrivateLayout exact path="/psychicbot-stats" pt={ dailyStatsChartPageType.suggestions } component={ DailyStats } />
                <PrivateLayout exact path="/userinfosearch" component={ UsersPage } />
                <PrivateLayout exact path="/cohortsearch" component={ CohortSearch } />
                <PrivateLayout exact path="/get-user-reports" component={ UserReports } />
                <PrivateLayout exact path="/psychics" component={ PsychicsPage } />
                <PrivateLayout exact path="/u-conversations" pt={ conversationPageType.unanswered24h } component={ ConversationsPage } />
                <PrivateLayout exact path="/p-conversations" pt={ conversationPageType.paid } component={ ConversationsPage } />
                <PrivateLayout exact path="/f-conversations" pt={ conversationPageType.free } component={ ConversationsPage } />
                <PrivateLayout exact path="/e-conversations" pt={ conversationPageType.empty } component={ ConversationsPage } />
                <PrivateLayout exact path="/conversation/:uuid" component={ ChatPage } />
              </Switch>
            </div>
          </BrowserRouter>
        </LocaleProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js